export const RESET_LOCAL_STORAGE_CONFIRMATION = "RESET LOCAL CLIENT DATA";
export const STORAGE_RECOVERY_MESSAGES = {
    "checksum-drift": "Local schema history does not match this client build",
    corrupt: "Local SQLite data failed its integrity check",
    "diagnostic-failed": "Encrypted storage diagnostic creation failed",
    "identity-source-unavailable": "Protected identity metadata is temporarily unavailable",
    "migration-failed": "Local SQLite schema migration failed",
    "opfs-unavailable": "Persistent browser storage is unavailable",
    "quota-exceeded": "Persistent browser storage quota is exhausted",
    "worker-operation-timeout": "Persistent storage operation timed out",
    "worker-preparation-timeout": "Protected storage request preparation timed out",
    "writer-conflict": "Another client-node storage writer is active",
};
//# sourceMappingURL=storage.js.map